import { Location, isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { APIConfigService } from "../../../src/shared/config/api-config";
import { AnalyticsService } from "../services/analytics.service";
import { HttpService } from "../services/http.service";
import { UtilsService } from "../services/utils.service";
import { CartDetailsService } from "../services/cart-details.service";
import { CartService } from "./cart.service";

@Injectable({
  providedIn: 'root'
})
export class SignInService {
  private token!: string;
  private refreshToken!: string;
  private name!: string;
  private isAuthenticated = false;
  public tokenTimer: any;
  private userId!: number;
  private userGuidId: any;
  private authStatusListener = new Subject<boolean>();
  timeOut: any;
  setTimeoutTimer: any;
  sessionTimer: any;
    sub: Subscription = new Subscription()

  constructor(private utils: UtilsService, private ApiConfig: APIConfigService,
    private httpService: HttpService,
    @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private _location: Location, private cartService: CartService, private service: CartDetailsService, private analyticsService: AnalyticsService) {
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }
  getIsAuth() {
    return this.isAuthenticated;
  }

  getToken() {
    if (isPlatformBrowser(this.platformId)) {

    let token: any = this.token ? this.token : localStorage.getItem('token')
    return token;
  }
}

  setSessionTimer() {
    // this.sessionTimer = setInterval(() => {
    //   const now = new Date().toISOString();
    //   let twk_action: any = this.utils.getItemFromLocalStorage('lms_action');
    //   const sessionTime = new Date(now).getTime() - new Date(twk_action).getTime();
    //   if (Math.floor((sessionTime / 1000) / 60) > 28) {
    //     //logout after inactivity of 29 mins
    //     this.logOut();
    //   }
    // }, 1000);
  }

  RefreshToken() {
    this.httpService.post(this.ApiConfig.end_points.REFRESH_TOKEN,
      { userGuid: this.utils.getUserGuid(), refreshToken: this.refreshToken },
      {})
      .subscribe({
        next: (res) => {
          if (res && res.accessToken && res.refreshToken) {
            this.token = res.accessToken;
            this.refreshToken = res.refreshToken;
            const now = new Date();
            const expirationDate = new Date(now.getTime() + this.utils.tokenExpirationTime * 1000);
            this.saveAuthData(this.token, expirationDate, this.refreshToken);
            clearInterval(this.tokenTimer);
            this.setAuthTimer(this.utils.tokenExpirationTime)
          }
        },
        error: (_err: any) => {
          this.clearAuthData();
          this.logOut();
        },
      })
  }

  RefreshTokenWithCallback(callback: any) {
    this.httpService.post(this.ApiConfig.end_points.REFRESH_TOKEN,
      { userGuid: this.utils.getUserGuid(), refreshToken: this.refreshToken },
      {})
      .subscribe({
        next: (res) => {
          if (res && res.accessToken && res.refreshToken) {
            this.token = res.accessToken;
            this.refreshToken = res.refreshToken;
            const now = new Date();
            const expirationDate = new Date(now.getTime() + this.utils.tokenExpirationTime * 1000);
            this.saveAuthData(this.token, expirationDate, this.refreshToken);
            clearInterval(this.tokenTimer);
            this.setAuthTimer(this.utils.tokenExpirationTime);
            callback(true);
          }
          else {
            callback(false);
          }
        },
        error: (_err: any) => {
          this.clearAuthData();
          this.logOut();
          callback(false);
        },
      })
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return
    }
    const now = new Date();
    const expiresInDuration = authInformation.expirationDate.getTime() - now.getTime();
    this.token = authInformation.token;
    this.isAuthenticated = true;
    this.authStatusListener.next(true);
    this.refreshToken = authInformation.refreshToken;
    this.userId = authInformation.userId;
    this.userGuidId = authInformation.userGuidId;
    this.name = authInformation.name as any;
    clearInterval(this.tokenTimer);
    clearTimeout(this.setTimeoutTimer);
    // this.setSessionTimer();
    if (expiresInDuration > 0) {
      this.callRefreshAfterCertainTime(expiresInDuration / 1000)
    } else {
      this.RefreshToken();
    }
  }

  signInEventTrigger(modeType: string, eventName: string) {
    const data = {
      eventName: eventName,
      eventData: {
        'Mode': modeType
      }
    };
    this.analyticsService.trackData(data);
  }

  callRefreshAfterCertainTime(duration: number) {
    this.setTimeoutTimer = setTimeout(() => {
      this.RefreshToken();
    }, duration * 1000);
  }

  LoginUser(url: string, payload: { [item: string]: any }, mode: string, httpOptions: any) {
      if (isPlatformBrowser(this.platformId)) {
    this.httpService.post(url, payload, httpOptions)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            localStorage.setItem('email',res['email']);
            // (<any>window).webengage.user.setAttribute('we_email', res['email']);
            // (<any>window).webengage.user.setAttribute('we_first_name', res['name']);
            // if (payload['phone']) {
            //   (<any>window).webengage.user.setAttribute('we_phone', payload['phone'].toString());
            // }
            // (<any>window).webengage.user.login(res['email']);

            let eventName = "User Signed In";
            if((mode === 'Google') && !res.isExistingUser){
              eventName = "User Signed Up";
            }
            this.signInEventTrigger(mode, eventName);
            const token = res.accessToken;
            const refreshToken = res.refreshToken;
            const name = res.name;
            const userId = res.userId;
            const userGuidId = res.userGuidID;
            this.token = token;
            this.refreshToken = refreshToken;
            this.name = name;
            this.userId = userId;
            this.userGuidId = userGuidId
            if (token) {
              const expiresInDuration = this.utils.tokenExpirationTime;
              this.setAuthTimer(expiresInDuration);
              // this.setSessionTimer();
              this.isAuthenticated = true;
              this.authStatusListener.next(true);
              const now = new Date();
              const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);
              this.saveAuthData(token, expirationDate, refreshToken, name, String(userId), String(userGuidId));
              this.utils.openSnackBar('Logged in successfully!', 'success-toster');
              if (this.utils.isBackToLastPage) {
                this.utils.isRecentLogin = true;
                this.getCartItems();
                // this._location.back();
                // this.utils.isBackToLastPage = false;
              }
              else {
                this.router.navigate(['/']);
                this.utils.isRecentLogin = true;
              }
            }
            this.utils.hideLoading();
          } else {
            this.utils.hideLoading();
            this.utils.openSnackBar(res.message, 'error-toster');
          }
        },
        error: (err: any) => {
          this.utils.hideLoading();
          this.utils.openSnackBar(err.error.message, 'error-toster');
        }
      })
    }
  }

 getCartItems() {
    if (isPlatformBrowser(this.platformId)) {

    if (this.utils.getToken()) {
      let encryptedCart: any = localStorage.getItem('cart');
      let cart: any = this.utils.decryptarrayText(encryptedCart);
      let cartObject: any = JSON.parse(cart);
      this.sub.add(this.cartService.getItems().subscribe({
        next: (response: any) => {
          if (response.success) {
            if (cartObject && cartObject.length) {
              this.cartService.processCartItems(cartObject, response, (updateCart: any) => {
                if (updateCart) {
                  this.sub.add(this.service.checkout().subscribe((data: any) => {
                  }))
                }
                this._location.back();
                this.utils.isBackToLastPage = false;
              }, (_emptyCart: any) => {
                this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                this.cartService.clearInfo();
                this.sub.add(this.service.checkout().subscribe((data: any) => {
                }))
                this._location.back();
                this.utils.isBackToLastPage = false;
              },
                false, this.utils.isRecentLogin ? true : false, (_pincodeChanged: any) => {
                  this.service.pinCodeChange();
                  this._location.back();
                  this.utils.isBackToLastPage = false;
                });
            }
            else {
              if (response.cartDetailList && response.cartDetailList.length) {
                this.utils.setUserPicode(response.cartDetailList[0].pincode);
                this.cartService.setInfo(response.cartDetailList, false);
                this._location.back();
                this.utils.isBackToLastPage = false;
              }
            }
            localStorage.removeItem('startTime')
            this.utils.hideLoading();
          }
          else {
            if (response && (response.statusCode != "204" && response.message != 'Record not found')) {
              this.cartService.clearInfo()
              this.utils.openSnackBar(response.message, 'error-toster');
            }
            else {
              if (cartObject && cartObject.length) {
                this.cartService.processCartItems(cartObject, response, (updateCart: any) => {
                  if (updateCart) {
                    this.sub.add(this.service.checkout().subscribe((data: any) => {
                    }))
                    this._location.back();
                    this.utils.isBackToLastPage = false;
                  }
                }, (_emptyCart: any) => {
                  this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                  this.cartService.clearInfo();
                  this.sub.add(this.service.checkout().subscribe((data: any) => {
                  }))
                  this._location.back();
                  this.utils.isBackToLastPage = false;
                },
                  false, this.utils.isRecentLogin ? true : false);
              }
            }
            this.utils.hideLoading();
          }
        }
      }))
    }
  }}

  logOut() {
    let payload = {
    }
    this.UserlogoutApiCall(payload)
      .subscribe({
        next: (_res: any) => {
      // if (isPlatformBrowser(this.platformId)) {

      //     (<any>window).webengage.user.logout();
      // }
          this.token = '';
          this.isAuthenticated = false;
          this.authStatusListener.next(false);
          this.clearAuthData();
          this.refreshToken = '';
          this.name = ''
          this.userId = 0;
          this.userGuidId = '';
          clearTimeout(this.setTimeoutTimer);
          clearTimeout(this.sessionTimer);
          clearInterval(this.tokenTimer);
          this.router.navigate(['/sign-in'])
          this.utils.hideLoading();
          this.utils.openSnackBar('Signed out successfully!', 'success-toster');
        },
        error: (err) => {
          this.utils.openSnackBar(err.message, 'error-toster');
          this.utils.hideLoading();
        }
      })
  }

  clearAuthData() {
    if (isPlatformBrowser(this.platformId)) {

    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expiration')
    localStorage.removeItem('name');
    localStorage.removeItem('userId');
    localStorage.removeItem('userGuidId');
    localStorage.removeItem('pinCode');
    localStorage.removeItem('buyNow');
    localStorage.removeItem('email');
    this.cartService.clearInfo()
    // let openPageCount: any = this.utils.getItemFromLocalStorage('lms_tab')
    // if (openPageCount > 1) {
    //   this.utils.setDoRefresh();
    // }
  }}

  private saveAuthData(token: string, expirationDate: Date, refreshToken: string, name?: string, userId?: string, userGuidId?: string) {
    if (isPlatformBrowser(this.platformId)) {

    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('expiration', expirationDate.toISOString())
    // let openPageCount: any = this.utils.getItemFromLocalStorage('lms_tab');
    // if (openPageCount > 1) {
    //   this.utils.setDoRefresh();
    // }
    if (name) {
      localStorage.setItem('name', name as any);
    }
    if (userId) {
      localStorage.setItem('userId', userId as any);
      localStorage.setItem('userGuidId', userGuidId as any);
    }
  }}

  public getAuthData() {
    if (isPlatformBrowser(this.platformId)) {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const expirationDate: string | null = localStorage.getItem('expiration')
    const name = localStorage.getItem('name');
    const userId = localStorage.getItem('userId');
    const userGuidId = localStorage.getItem('userGuidId');
    if (!token || !refreshToken) {
      return
    }
    return {
      token: token,
      refreshToken: refreshToken,
      expirationDate: new Date(expirationDate as any),
      name: name,
      userId: Number(userId),
      userGuidId: userGuidId
    }
  }else{
    return null;
  }
}

  setAuthTimer(duration: number) {
    this.tokenTimer = setInterval(() => {
      this.RefreshToken();
    }, duration * 1000)
  }

  UserlogoutApiCall(payload: any) {
    return this.httpService.post(this.ApiConfig.end_points.LOG_OUT, payload, {})
  }

  ActivateUserEmail(payload: any) {
    return this.httpService.post(this.ApiConfig.end_points.VERIFY_EMAIL, payload, {})
    //return this.httpService.post(this.ApiConfig.end_points.VERIFY_EMAIL, payload, {}).pipe(catchError(this.utils.processError));

  }

}
